import { css } from '@emotion/css';
import { Theme } from 'src/lib/theme/types';

export const main = (_: Theme) => css`
  display: flex;
  align-items: center;
  border: none;
  min-height: 50px;
`;
